import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, makeStyles } from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';
import merge from 'lodash/merge';
import { useMultiStepDrawer } from '../../../context';
const useStyles = makeStyles((theme) => ({
    primaryButtonContainer: {
        [theme.breakpoints.only('xs')]: {
            minHeight: 'auto',
            flexDirection: 'column',
            display: 'flex',
            paddingBottom: theme.spacing(0),
        },
        [theme.breakpoints.up('sm')]: {
            '& > :first-child': {
                marginLeft: theme.spacing(2),
            },
            display: 'flex',
            flexDirection: 'row-reverse',
        },
    },
    dismissButton: {
        background: 'transparent',
        color: theme.palette.primary.main,
    },
}));
/**
 * PrimaryActionButton component for the MultiStepDrawer.
 *
 * This component renders the primary action button and the dismiss action button
 * for the MultiStepDrawer. The primary action button's label and behavior can be
 * customized via props or from setPrimaryActionButton({...props}) supplied by useMultiStepDrawer.Specific to MultiDrawers this defaults to "Next" or "Done" based on the step.
 * The dismiss action button is also customizable and defaults to closing the drawer.
 *
 * @param props - The props for the PrimaryActionButton component.
 * @param props.dismissActionProps - Optional props for the dismiss action button.
 * @param props.primaryActionProps - Optional props for the primary action button.
 * @returns The PrimaryActionButton component.
 */
export const PrimaryActionButton = (props) => {
    const classes = useStyles();
    const { primaryActionProps, dismissActionProps, nextStep, isLastStep, setDrawerIsOpen } = useMultiStepDrawer();
    const mergedPrimaryProps = merge({}, primaryActionProps, props.primaryActionProps);
    const defaultPrimaryLabel = !isLastStep ? 'Next' : 'Done';
    const primaryLabel = mergedPrimaryProps.label ?? defaultPrimaryLabel;
    const mergedDismissProps = merge({}, dismissActionProps, props.dismissActionProps);
    const dismissLabel = mergedDismissProps.label ?? 'Cancel';
    return (_jsxs("div", { className: classes.primaryButtonContainer, children: [!mergedPrimaryProps.hidden && (_jsx(Button, { variant: 'contained', color: 'primary', endIcon: !isLastStep ? _jsx(ArrowForward, {}) : undefined, onClick: nextStep, ...mergedPrimaryProps, children: primaryLabel })), !mergedDismissProps.hidden && (_jsx(Button, { className: classes.dismissButton, variant: 'outlined', id: 'dismiss-action', onClick: () => setDrawerIsOpen(false), ...mergedDismissProps, children: dismissLabel }))] }));
};
